import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Phone, ArrowRight, MapPin } from "lucide-react";

export function PartnerGo() {
  const { code, key } = useParams();
  useEffect(() => { window.location.replace(`${API}/p/${encodeURIComponent(code)}/${encodeURIComponent(key)}`); }, [code, key]);
  return <div className="h-[50vh] grid place-items-center"><Loader2 className="h-6 w-6 animate-spin text-sam-crimson" /></div>;
}

export default function PartnerProfile() {
  const { code } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/partners/${encodeURIComponent(code)}`).then(({ data }) => setP(data)).catch(() => setP(false)); }, [code]);
  useEffect(() => { if (p) { document.title = `${p.display_name} | Saving America Money`; } }, [p]);
  if (p === null) return <div className="h-[50vh] grid place-items-center"><Loader2 className="h-6 w-6 animate-spin text-sam-crimson" /></div>;
  if (!p) return <div className="mx-auto max-w-xl px-4 py-20 text-center text-sam-slate" data-testid="partner-not-found">Partner not found.</div>;
  return (
    <div className="mx-auto max-w-xl px-4 py-12" data-testid="partner-profile">
      <div className="text-center">
        {p.photo_url ? <img src={p.photo_url} alt={p.display_name} className="mx-auto h-28 w-28 rounded-full object-cover border-4 border-white shadow" />
          : <div className="mx-auto h-28 w-28 rounded-full bg-sam-navy text-white grid place-items-center font-display text-4xl font-black">{p.display_name[0]}</div>}
        <h1 className="mt-4 font-display text-3xl font-black text-sam-navy" data-testid="partner-name">{p.display_name}</h1>
        <p className="text-sm text-sam-crimson font-semibold" data-testid="partner-headline">{p.headline}</p>
        {p.city && <p className="mt-1 text-xs text-sam-slate inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{p.city}</p>}
        {p.bio && <p className="mt-4 text-sm text-sam-slate whitespace-pre-wrap" data-testid="partner-bio">{p.bio}</p>}
      </div>
      <div className="mt-8 space-y-3">
        {Object.entries(p.links).map(([k, url]) => (
          <Button key={k} asChild className="w-full h-12 bg-sam-navy hover:bg-sam-navy2 text-base"><a href={url} data-testid={`partner-link-${k}`}>{p.labels[k]} <ArrowRight className="h-4 w-4 ml-2" /></a></Button>
        ))}
        {p.business?.features?.phone && p.business.phone && <Button asChild variant="outline" className="w-full h-12"><a href={`tel:${p.business.phone}`} data-testid="partner-phone"><Phone className="h-4 w-4 mr-2" />{p.business.phone}</a></Button>}
        {p.business && [["website", "Website"], ["facebook", "Facebook"], ["instagram", "Instagram"]].filter(([k]) => p.business.has_links?.[k]).map(([k, l]) => (
          <Button key={k} asChild variant="outline" className="w-full h-12"><a href={`${API}/out/${p.business.id}/${k}`} target="_blank" rel="noreferrer" data-testid={`partner-biz-${k}`}>{l}</a></Button>
        ))}
        {p.business && <Button asChild variant="outline" className="w-full h-12"><Link to={`/business/${p.business.slug}`} data-testid="partner-business">{p.business.name}</Link></Button>}
      </div>
      <p className="mt-10 text-center text-xs text-sam-slate">Saving America Money partner</p>
    </div>
  );
}
